<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-toolbar class="custom-toolbar">
  <ion-searchbar
    #airportSearch
    mode="ios"
    placeholder="{{
      getPlaceholderText() | translate
    }}"
    (keyup.enter)="filterAirportLIstOnEnter($event)"
    (ionInput)="filterAirportLIst($event)"
  >
  </ion-searchbar>
</ion-toolbar>

<ion-content>
  <ion-grid
    *ngIf="noData && page === 1; else showAirportList"
    class="ion-text-center v-center"
  >
    <ion-row>
      <ion-col size="12">
        <ion-label class="fs-3 font500 text-color">{{
          "airport_list.airport_not_available" | translate
        }}</ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #showAirportList>
    <ion-list class="ion-list-transparent-bg-color">
      <ion-item
        lines="inset"
        class="ion-justify-content-start ion-no-padding ion-item-transparent-bg-color"
        *ngFor="let airport of airportList"
        (click)="selectAiport(airport)"
      >
        <ion-chip class="white-chip custom-chip">{{ airport.airportCode }}</ion-chip>
        <ion-label>
          <p class="fs-3 font500 airport_name airport-container paragraph-primary-text-color line-1-clip">
            {{ airport.airportName }}
          </p>
          <div class="d-flex ion-justify-content-between">
            <p
              class="fs-2 font400 airport_city paragraph-secondary-text-color ion-no-margin"
            >
              {{ airport.city }} , {{ airport.country }}
            </p>
            <ion-chip
              class="primary-chip fs-2 chip-height"
              *ngIf="airport?.tag && !type && showLocalOfferTag"
            >
              {{ airport?.tag }}
            </ion-chip>
          </div>
        </ion-label>
      </ion-item>
    </ion-list>

    <div *ngIf="airportList.length <= 0 && noData === 0 && !hasError">
      <ion-list class="ion-list-transparent-bg-color">
        <ion-item
          *ngFor="let item of [0, 1, 2, 3, 4, 5, 6, 7]"
          class="ion-item-transparent-bg-color"
        >
          <ion-label>
            <h3>
              <ion-skeleton-text
                animated
                style="width: 80%; height: 16px"
              ></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text
                animated
                style="width: 50%"
              ></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </ng-template>

  <app-inline-generic-error *ngIf="hasError"></app-inline-generic-error>

  <ion-infinite-scroll (ionInfinite)="getNextPage($event)" *ngIf="!hasError" >
    <ion-infinite-scroll-content> </ion-infinite-scroll-content>
  </ion-infinite-scroll>

</ion-content>
